import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { take } from 'rxjs';
import { slideInOut } from '../../animations/slide-in-out.animation';
import { opacityInOut } from '../../animations/opacity-in-out.animation';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'a-select-multiple',
  templateUrl: 'a-select-multiple.component.html',
  styleUrls: ['a-select-multiple.component.scss'],
  animations: [slideInOut, opacityInOut]
})
export class ASelectMultipleComponent {

  @ViewChild('scrolledEl') scrolledEl: ElementRef | undefined;
  @ViewChild('selectEl') selectEl: ElementRef | undefined;
  @Input() isSubmitted = true;
  @Input() label = '';
  @Input() grayBg = true;
  @Input() isOptional = false;
  @Input() valueKey = 'value';
  @Input() errorMessage = null;
  @Input() control: FormControl = new FormControl();
  @Input() disableSelectedList = false;
  @Input() maxItems: number | null = null;
  @Input() set items(vals) {
    if (vals) { this.setValues(vals); }
  }
  @Output() itemChanged = new EventEmitter<any>();
  @Output() onBlur = new EventEmitter<any>();
  @Output() maxItemsReached = new EventEmitter<void>();

  selectedItems = [];
  showItems = false;
  inputFocused = false;
  openPositionTop = false;
  searchValue = '';
  allItems = null;
  shadowItems = null;

  constructor() {
  }

  onFocus(val: boolean) {
    this.inputFocused = val;
    if (this.inputFocused) {
      this.showDropdown();
      this.shadowItems = this.allItems;
    } else {
      this.selectEl.nativeElement.value = '';
    }
  }

  showDropdown(val: boolean = true) {
    this.showItems = val;
    if (this.selectEl) {
      const position = this.selectEl.nativeElement.getBoundingClientRect().top;
      this.openPositionTop = getWindow().innerHeight - position < 240;
    }
  }

  selectItem(val: any) {
    if (val) {
      if (this.selectedItems.includes(val[this.valueKey])) {
        this.selectedItems = this.selectedItems.filter(item => item !== val[this.valueKey]);
        this.itemChanged.emit({ skill: val, add: false });
      } else {
        // Check if we can add more items based on maxItems limit
        if (this.maxItems && this.selectedItems.length >= this.maxItems) {
          this.maxItemsReached.emit(); // Emit event when max items reached
          return; // Prevent adding more items if limit is reached
        }
        this.selectedItems = [...this.selectedItems, val[this.valueKey]];
        this.itemChanged.emit({ skill: val, add: true });
      }
      this.searchValue = '';
      this.showDropdown(false);
      this.control.setValue(this.selectedItems);
      this.onBlur.emit();
    }
  }

  removeSelected(val) {
    this.selectedItems = this.selectedItems.filter(item => item !== val);
    this.control.setValue(this.selectedItems);
    this.onBlur.emit();
  }

  findResult(val: any) {
    this.shadowItems = this.allItems.filter((item: any) => item[this.valueKey].toLowerCase().includes(val.toLowerCase()));
  }

  private setValues(vals) {
    setTimeout(() => {
      this.shadowItems = this.allItems = vals;
      const selectedValue = this.control.value;
      if (selectedValue && selectedValue.length) {
        this.selectedItems = selectedValue;
      } else {
        this.control.valueChanges.pipe(take(1)).subscribe(val => {
          if (val && val.length) {
            this.selectedItems = val;
          }
        });
      }
    })
  }
}
